var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22222 56C4.51111 56 3.04578 55.3913 1.82622 54.1738C0.60874 52.9542 0 51.4889 0 49.7778V6.22222C0 4.51111 0.60874 3.04578 1.82622 1.82622C3.04578 0.60874 4.51111 0 6.22222 0H49.7778C51.4889 0 52.9542 0.60874 54.1738 1.82622C55.3913 3.04578 56 4.51111 56 6.22222V49.7778C56 51.4889 55.3913 52.9542 54.1738 54.1738C52.9542 55.3913 51.4889 56 49.7778 56H6.22222ZM6.22222 49.7778H49.7778V6.22222H6.22222V49.7778ZM9.33333 43.5556H46.6667L35 28L25.6667 40.4444L18.6667 31.1111L9.33333 43.5556ZM6.22222 49.7778V6.22222V49.7778Z",
    fill: "#551FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/imageIcon.8faf0f0a70e3646d0b29a2ccdc9139b0.svg";
export { ForwardRef as ReactComponent };